import gql from "graphql-tag";

export const GET_VISITOR_INVOICES_PREVIEW = gql`
  query ($invoiceId: ID!) {
    getVisitorInvoicePreview(invoiceId: $invoiceId)
  }
`;
